import 'imagesloaded/imagesloaded.pkgd.min.js';
import 'isotope-layout/dist/isotope.pkgd.min.js';

function getHashFilter() {
	//var hash = location.hash;
	// get filter=filterName
	var matches = location.hash.match( /category=([^&]+)/i );
	var hashFilter = matches && matches[1];
	return hashFilter && decodeURIComponent( hashFilter );
}

export default function () {

	if ( $('.projects__grid').length > 0 ) {

		var isIsotopeInit = false;

		var hashFilter = getHashFilter();
		if ( !hashFilter && isIsotopeInit ) {
			return;
		}
		isIsotopeInit = true;
		// filter isotope
		var $grid = $('.projects__grid').imagesLoaded( function() {
			// init Isotope after all images have loaded
			$grid.isotope({
				// options...
				itemSelector: '.projects__item',
				percentPosition: true,
				filter: hashFilter,
				masonry: {
					// set to the element
					columnWidth: '.grid-sizer',
					gutter: '.gutter-sizer'
				}
			});
		});
		// set selected class on button
		if ( hashFilter ) {
			$('.projects__filter-item').find('.active').removeClass('active');
			$('.projects__filter-item').find('[data-filter="' + hashFilter + '"]').addClass('active');
		}
	}	

}


// WEBPACK FOOTER //
// ./scripts/components/SetupHashChange.js